export default __webpack_public_path__ + "static/media/3.b6d41b11.svg";